import React, { useState } from "react";

function AddVoucherForm({ onAddVoucherComplete }) {
  const [voucherType, setVoucherType] = useState("");
  const [voucherValue, setVoucherValue] = useState("");
  const [description, setDescription] = useState("");
  const [voucherImage, setVoucherImage] = useState(null);

  const handleImageChange = (e) => {
    setVoucherImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("voucherType", voucherType);
    formData.append("voucherValue", voucherValue);
    formData.append("description", description);
    formData.append("voucherImage", voucherImage);

    const response = await fetch("/api/upload-voucher", {
      method: "POST",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: formData,
    });

    if (response.ok) {
      alert("Voucher added successfully!");
      onAddVoucherComplete(); // Call the parent callback to refresh list
    } else {
      const data = await response.json().catch(() => ({}));
      alert(
        response.status === 401 || response.status === 403
          ? "Your session has expired. Please log in again."
          : data.error || "Failed to add voucher."
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Add Voucher</h3>
      <input
        type="text" 
        placeholder="Voucher Name"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        required
      />
      <select
        value={voucherType}
        onChange={(e) => setVoucherType(e.target.value)}
        required
      >
        <option value="">Select Voucher Type</option>
        <option value="Amount">Amount</option>
        <option value="Percentage">Percentage</option>
      </select>
      <input
        type="number"
        placeholder="Voucher Value"
        value={voucherValue}
        onChange={(e) => setVoucherValue(e.target.value)}
        required
      />

      <input 
        type="file" 
        accept="image/jpeg,image/png,image/webp" 
        onChange={handleImageChange} 
        required />
      <button type="submit">Submit</button>
    </form>
  );
}

export default AddVoucherForm;
